import zhCN from './json/answer-card.zh_CN.json';
import zhTW from './json/answer-card.zh_TW.json';
import en from './json/answer-card.en.json';
import ja from './json/answer-card.ja.json';
import ko from './json/answer-card.ko.json';
import ru from './json/answer-card.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
